import React from 'react';

// Same crew list as CrewSelector
const CREWS = [
  // Individual crew members (main installers)
  { id: 'adam', name: 'Adam', type: 'individual' },
  { id: 'kevin', name: 'Kevin', type: 'individual' },
  { id: 'steve', name: 'Steve', type: 'individual' },
  
  // Teams of 2
  { id: 'adam-kevin', name: 'Adam + Kevin', type: 'team' },
  { id: 'adam-steve', name: 'Adam + Steve', type: 'team' },
  { id: 'kevin-steve', name: 'Kevin + Steve', type: 'team' },
  
  // Team of 3
  { id: 'adam-kevin-steve', name: 'Adam + Kevin + Steve', type: 'team' },
  
  // Small job crew (deliveries, single windows)
  { id: 'mike', name: 'Mike (Small Jobs)', type: 'small' },
  { id: 'justin', name: 'Justin (Small Jobs)', type: 'small' }
];

export default function WorkScopeSection({ formData, onChange }) {
  // Group crews by type
  const individuals = CREWS.filter(c => c.type === 'individual');
  const teams = CREWS.filter(c => c.type === 'team');
  const smallJobs = CREWS.filter(c => c.type === 'small');

  return (
    <div>
      <h3 style={{
        fontSize: '16px',
        fontWeight: '600',
        color: 'var(--text-primary)',
        marginBottom: '16px'
      }}>
        Work Scope
      </h3>

      {/* Window Count */}
      <div style={{ marginBottom: '16px' }}>
        <label style={{
          display: 'block',
          fontSize: '13px',
          fontWeight: '600',
          color: 'var(--text-primary)',
          marginBottom: '6px'
        }}>
          Number of Windows
        </label>
        <input
          type="number"
          min="0"
          value={formData.windowCount || 0}
          onChange={(e) => onChange({ windowCount: parseInt(e.target.value) || 0 })}
          style={{
            width: '100%',
            padding: '10px 12px',
            border: '1px solid var(--input-border)',
            borderRadius: '8px',
            fontSize: '14px',
            outline: 'none'
          }}
          onFocus={(e) => e.target.style.borderColor = 'var(--brand-brown)'}
          onBlur={(e) => e.target.style.borderColor = 'var(--input-border)'}
        />
      </div>

      {/* Door Count */}
      <div style={{ marginBottom: '16px' }}>
        <label style={{
          display: 'block',
          fontSize: '13px',
          fontWeight: '600',
          color: 'var(--text-primary)',
          marginBottom: '6px'
        }}>
          Number of Doors
        </label>
        <input
          type="number"
          min="0"
          value={formData.doorCount || 0}
          onChange={(e) => onChange({ doorCount: parseInt(e.target.value) || 0 })}
          style={{
            width: '100%',
            padding: '10px 12px',
            border: '1px solid var(--input-border)',
            borderRadius: '8px',
            fontSize: '14px',
            outline: 'none'
          }}
          onFocus={(e) => e.target.style.borderColor = 'var(--brand-brown)'}
          onBlur={(e) => e.target.style.borderColor = 'var(--input-border)'}
        />
      </div>

      {/* Duration */}
      <div style={{ marginBottom: '16px' }}>
        <label style={{
          display: 'block',
          fontSize: '13px',
          fontWeight: '600',
          color: 'var(--text-primary)',
          marginBottom: '6px'
        }}>
          Estimated Duration (work days)
        </label>
        <input
          type="number"
          min="1"
          value={formData.durationDays || 1}
          onChange={(e) => onChange({ durationDays: parseInt(e.target.value) || 1 })}
          style={{
            width: '100%',
            padding: '10px 12px',
            border: '1px solid var(--input-border)',
            borderRadius: '8px',
            fontSize: '14px',
            outline: 'none'
          }}
          onFocus={(e) => e.target.style.borderColor = 'var(--brand-brown)'}
          onBlur={(e) => e.target.style.borderColor = 'var(--input-border)'}
        />
        <div style={{
          fontSize: '11px',
          color: 'var(--text-tertiary)',
          marginTop: '4px'
        }}>
          Weekends are automatically skipped
        </div>
      </div>

      {/* Assigned Crew */}
      <div style={{ marginBottom: '16px' }}>
        <label style={{
          display: 'block',
          fontSize: '13px',
          fontWeight: '600',
          color: 'var(--text-primary)',
          marginBottom: '6px'
        }}>
          Assigned Crew (optional)
        </label>
        <select
          value={formData.assignedCrew || ''}
          onChange={(e) => onChange({ assignedCrew: e.target.value })}
          style={{
            width: '100%',
            padding: '10px 12px',
            border: '1px solid var(--input-border)',
            borderRadius: '8px',
            fontSize: '14px',
            outline: 'none',
            background: 'var(--bg-tertiary)'
          }}
          onFocus={(e) => e.target.style.borderColor = 'var(--brand-brown)'}
          onBlur={(e) => e.target.style.borderColor = 'var(--input-border)'}
        >
          <option value="">Not assigned</option>
          
          <optgroup label="👷 Individual Installers">
            {individuals.map(crew => (
              <option key={crew.id} value={crew.id}>
                {crew.name}
              </option>
            ))}
          </optgroup>
          
          <optgroup label="👷👷 Installation Teams">
            {teams.map(crew => (
              <option key={crew.id} value={crew.id}>
                {crew.name}
              </option>
            ))}
          </optgroup>
          
          <optgroup label="🚚 Small Jobs / Delivery">
            {smallJobs.map(crew => (
              <option key={crew.id} value={crew.id}>
                {crew.name}
              </option>
            ))}
          </optgroup>
        </select>
      </div>

      <div style={{
        height: '1px',
        background: 'var(--cell-border)',
        margin: '24px 0'
      }} />

      {/* Flags */}
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '12px'
      }}>
        {/* Is Repair */}
        <label style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          cursor: 'pointer'
        }}>
          <input
            type="checkbox"
            checked={formData.isRepair || false}
            onChange={(e) => onChange({ isRepair: e.target.checked })}
            style={{
              width: '18px',
              height: '18px',
              cursor: 'pointer'
            }}
          />
          <span style={{
            fontSize: '14px',
            color: 'var(--text-primary)'
          }}>
            This is a repair job
          </span>
        </label>

        {/* Is Delivery Only */}
        <label style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          cursor: 'pointer'
        }}>
          <input
            type="checkbox"
            checked={formData.isDeliveryOnly || false}
            onChange={(e) => onChange({ isDeliveryOnly: e.target.checked })}
            style={{
              width: '18px',
              height: '18px',
              cursor: 'pointer'
            }}
          />
          <span style={{
            fontSize: '14px',
            color: 'var(--text-primary)'
          }}>
            Delivery only (no installation)
          </span>
        </label>

        {/* Is Pickup at Shop */}
        <label style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          cursor: 'pointer'
        }}>
          <input
            type="checkbox"
            checked={formData.isPickupAtShop || false}
            onChange={(e) => onChange({ isPickupAtShop: e.target.checked })}
            style={{
              width: '18px',
              height: '18px',
              cursor: 'pointer'
            }}
          />
          <span style={{
            fontSize: '14px',
            color: 'var(--text-primary)'
          }}>
            Customer pickup at shop
          </span>
        </label>
      </div>
    </div>
  );
}